import useScreen from "../hooks/useScreen";

export const useSourcePhoto = () => {
  const platform: string =
    new URLSearchParams(location.search).get("platform") ?? "";
  const { isMobile } = useScreen();

  return platform.includes("g-mob")
    ? "native"
    : isMobile
    ? "mobile"
    : "desktop";
};
